import React from 'react';
import { motion } from 'motion/react';

interface MarketplaceCategoryTabsProps {
  activeCategory: string;
  categories: string[];
  onSelectCategory: (category: string) => void;
}

export const MarketplaceCategoryTabs: React.FC<MarketplaceCategoryTabsProps> = ({
  activeCategory,
  categories,
  onSelectCategory,
}) => {
  return (
    <div className="flex flex-wrap gap-1 border-t border-zinc-900/70 pt-3">
      {categories.map((cat) => {
        const isActive = activeCategory === cat;
        return (
          <button
            key={cat}
            id={`category-tab-${cat.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`}
            onClick={() => onSelectCategory(cat)}
            className="relative py-1.5 px-3 rounded-lg font-mono text-[9px] font-black uppercase tracking-wider cursor-pointer transition-all duration-200 focus:outline-none"
          >
            {isActive && (
              <motion.div
                layoutId="activeCategoryIndicator"
                className="absolute inset-0 bg-[#e840f3]/15 border border-[#e840f3]/45 rounded-lg shadow-[0_0_12px_rgba(232,64,243,0.15)]"
                transition={{ type: 'spring', stiffness: 350, damping: 30 }}
              />
            )}
            <span className={`relative z-10 transition-colors ${isActive ? 'text-[#e840f3]' : 'text-slate-500 hover:text-slate-300'}`}>
              {cat}
            </span>
          </button>
        );
      })}
    </div>
  );
};
